import { gql } from '@apollo/client'
import { PDNFragments } from '../fragments/productDetailNote.fragment'

export const ProductLogFragment = gql`
    fragment productHistoryLog on ProductListingLog {
        listingId
        isActive
        action
        specAgentProductTypeId
        user {
            userFullName
            email
        }
        productDetailNotes {
            ...pdnCommonFragment
        }
        timeStamp
        type
        submissionStatus
    }
    ${PDNFragments.pdnCommonFragment}
`

export const getProductListingsHistory = gql`
    query getProductListingLogs($input: GetProductListingLogInput!) {
        getProductListingLogs(input: $input) {
            skip
            limit
            totalResult
            logs {
                ...productHistoryLog
            }
        }
    }
    ${ProductLogFragment}
`

export const getBPMProductListingsHistory = gql`
    query getProductListingLogs($input: GetProductListingLogInput!) {
        getProductListingLogs(input: $input) {
            skip
            limit
            totalResult
            logs {
                listingId
                isActive
                action
                specAgentProductTypeId
                user {
                    userFullName
                    email
                }
                timeStamp
                type
                submissionStatus
            }
        }
    }
`
